import { createWebHistory, createRouter } from "vue-router";
import { routes } from "./routes";
import { updateCanonicalTag } from "../../utilities";
import store from "../../store";

const defaultTitle = "Guiide";
const defaultDescription = "Guiide, give your pensions some love";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
        top: -30,
      };
    }

    if (savedPosition) return savedPosition;

    return { top: 0 };
  },
});

router.afterEach((to, from) => {
  const monitor = store.state.configuration.monitor;

  if (to.meta) {
    const title = to.meta.title ? `Guiide | ${to.meta.title}` : defaultTitle;
    const description = to.meta.description ? to.meta.description : defaultDescription;

    document.title = title;
    document
      .querySelectorAll(".document-title")
      .forEach((el) => el.setAttribute("content", title));
    document
      .querySelectorAll(".document-description")
      .forEach((el) => el.setAttribute("content", description));

    const canonicalUrl = `${window.location.origin}${to.path}`;
    updateCanonicalTag(canonicalUrl);

    if (monitor) {
      const aiLogInfo = {
        name: to.path,
        uri: window.location.href,
        properties: {
          route: to.fullPath,
          fromRoute: from.fullPath
        }
      };

      if (window.appInsights) {
        window.appInsights.trackPageView(aiLogInfo);
      }

      window.fbq('track', 'PageView');
      window.uetq.push({ 'ec':'pageLoad', 'ea':'PageView', 'el':`/${to.path}` });
    }
  }
});

export default router;
